import React from "react";
import CustomizableAvatar from "../common/CustomizableAvatar";
import MainAvatar from "../../assets/main-avatar.png";
import Smartlend from "../../assets/SMARTLEND.png";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import FormikControl from "./ReusableFormik/FormikControl";
import axios from "axios";
import Loading from "../common/Loading";

const PersonalDetails = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    firstName: "",
    lastName: "",
    role: "",
    id: "",
  };

  // validation
  const validationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    role: Yup.string().required("Required"),
  });

  //   Form submission
  const params = useParams();
  const id = params.id;

  const onSubmit = async (values) => {
    try {
      values["id"] = id;
      setIsSubmitting(true);

      // Make API request to submit form data
      const response = await axios.post(
        "https://smartapp-lendbackend.onrender.com/api/admin/signup/personal", values);
      // const userId = response.data.newUser.id;

      // Handle the API response
      console.log("API response", response.data);

      // Navigate to "/add team" route on successful submission
      navigate(`/addTeam/${id}`);
    } catch (error) {
      // Handle any errors that occurred during the API request
      console.error("API error", error);
      alert(error.response.data);
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <main className="">
      <section className="container my-0  mx-auto">
        <section>
          <div className=" p-4 px-4 md:p-8">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
              <CustomizableAvatar src={MainAvatar} className="px-1" />

              <div className=" pl-10 lg:col-span-2">
                <CustomizableAvatar src={Smartlend} customClass={"py-3 pb-5"} />
                <p className="text-2xl py-3">Personal detail</p>

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(formik) => {
                    return (
                      <Form className="container w-9/12">
                        <FormikControl
                          control="input"
                          label="First name (required)"
                          type="text"
                          placeholder="e.g. Oluwatofunmi"
                          name="firstName"
                        />

                        <FormikControl
                          control="input"
                          label="Last name (required)"
                          type="text"
                          placeholder="e.g. Idowu"
                          name="lastName"
                        />

                        <FormikControl
                          control="input"
                          label="Role (required)"
                          type="text"
                          placeholder="e.g. Bank manager"
                          name="role"
                        />

                        <FormikControl
                          control="input"
                          id="id"
                          // value={id}
                          type="text"
                          hidden
                          name="id"
                        />

                        <button
                          type="submit"
                          className="bg-indigo-500 text-slate-50 border rounded  cursor-pointer mt-5 py-1 px-14 hover:bg-indigo-600"
                          disabled={!formik.isValid || isSubmitting}
                        >
                          {isSubmitting ? (
                            <Loading
                              type="spinningBubbles"
                              color="#FFF"
                              height={20}
                              width={20}
                            />
                          ) : (
                            "Continue"
                          )}
                        </button>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  );
};

export default PersonalDetails;